import React from 'react';

const formatMessageText = (text) => {
  return text.split(/(\*\*.*?\*\*)/g).map((part, index) => {
    if (part.startsWith('**') && part.endsWith('**')) {
      const content = part.slice(2, -2);
      return <span key={index} style={{ fontWeight: 'bold', fontStyle: 'italic' }}>{content}</span>;
    }
    return part;
  });
};

export default function AskMePanel({
  setShowAskMe, setAskMeInput, setAskMeResult,
  askMeMessages, askMeLoading, askMeCurrentMessage,
  setAskMeCurrentMessage, askMeMessagesEndRef,
  handleAskMeSendMessage, clearAskMeHistory,
}) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 8, transition: 'opacity 0.22s, transform 0.22s', height: '400px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
          <button onClick={() => { setShowAskMe(false); setAskMeInput(""); setAskMeResult(""); }} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0, marginRight: 4, transition: 'color 0.18s' }}>
            <svg width="18" height="18" viewBox="0 0 20 20" fill="none"><path d="M12 16l-4-4 4-4" stroke="#8a2be2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
          </button>
          <h3 style={{ margin: 0, fontSize: '16px', color: '#333' }}>AI Chat</h3>
        </div>
        <button
          onClick={clearAskMeHistory}
          style={{ padding: '4px 8px', fontSize: '12px', background: '#000', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer' }}
        >
          Clear
        </button>
      </div>

      <div style={{ flex: 1, overflowY: 'auto', padding: '12px', background: 'transparent', borderRadius: '8px', border: 'none', maxHeight: '300px' }}>
        {askMeMessages.map((message) => (
          <div key={message.id} style={{ marginBottom: '12px', display: 'flex', flexDirection: 'column', alignItems: message.type === 'user' ? 'flex-end' : 'flex-start' }}>
            <div style={{
              maxWidth: '80%', padding: '10px 14px', borderRadius: '12px',
              background: message.type === 'user' ? '#90caf9' : '#fff',
              color: message.type === 'user' ? '#fff' : '#333',
              border: message.type === 'assistant' ? '1px solid #e9ecef' : 'none',
              boxShadow: message.type === 'assistant' ? '0 2px 4px rgba(0,0,0,0.1)' : 'none',
              wordWrap: 'break-word', whiteSpace: 'pre-wrap', fontSize: '14px'
            }}>
              {formatMessageText(message.content)}
            </div>
            <div style={{ fontSize: '10px', color: '#666', marginTop: '4px', marginLeft: message.type === 'user' ? '0' : '8px', marginRight: message.type === 'user' ? '8px' : '0' }}>
              {message.timestamp.toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' })}
            </div>
          </div>
        ))}
        {askMeLoading && (
          <div style={{ display: 'flex', justifyContent: 'flex-start', marginBottom: '12px' }}>
            <div style={{ padding: '10px 14px', borderRadius: '12px', background: '#fff', border: '1px solid #e9ecef', color: '#666', fontSize: '14px' }}>
              Thinking...
            </div>
          </div>
        )}
        <div ref={askMeMessagesEndRef} />
      </div>

      <div style={{ display: 'flex', gap: '6px' }}>
        <input
          value={askMeCurrentMessage}
          onChange={(e) => setAskMeCurrentMessage(e.target.value)}
          onKeyDown={(e) => { if (e.key === 'Enter' && !askMeLoading) { e.preventDefault(); handleAskMeSendMessage(); } }}
          placeholder="Type a message..."
          style={{ flex: 1, padding: '8px 12px', borderRadius: '8px', border: '1.5px solid #cfcfff', background: '#f7fbff', fontSize: '14px', transition: 'border 0.18s, background 0.18s' }}
        />
        <button
          onClick={handleAskMeSendMessage}
          disabled={!askMeCurrentMessage.trim() || askMeLoading}
          style={{
            padding: '8px 16px', borderRadius: '8px', border: 'none',
            background: askMeCurrentMessage.trim() && !askMeLoading ? '#000' : '#ccc',
            color: '#fff', cursor: askMeCurrentMessage.trim() && !askMeLoading ? 'pointer' : 'not-allowed',
            fontWeight: 600, fontSize: '14px'
          }}
        >
          Send
        </button>
      </div>
    </div>
  );
}
